export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6807.09cd19aa.jpg";